import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UsersService } from '../users/users.service';
import { SessionService } from '../session/session.service';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class AuthgaurdService implements CanActivate {

  constructor(private UsersService: UsersService, private router: Router, private SessionService: SessionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(route.data.auth && this.UsersService[route.data.auth]()){
      return true;
    }
    else if (!route.data.auth && this.SessionService.loggedInUser() && this.SessionService.loggedInUser() != null) {
      return true;
    }
    else {
      this.router.navigate(['/']);
      return false;
    }
  };

}
